import { createFileRoute } from '@tanstack/react-router';

import {
    useSaveT360LeafTags,
    useT360ClusterTree,
    useT360TagConfig,
} from '@/features/Transition360/api';
import { LabelsTab } from '@/features/Transition360/Labels/LabelsTab';
import { resolveTagsToSave } from '@/features/Transition360/Labels/utils';
import { PageState } from '@/features/Transition360/ui/PageState';
import { apiErrorMessage } from '@/features/Transition360/ui/apiErrorMessage';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/labels',
)({
    component: LabelsTabRoute,
});

function LabelsTabRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    const tree = useT360ClusterTree(projectId, projectAssetId);
    const config = useT360TagConfig();
    const saveLeafTags = useSaveT360LeafTags(projectId, projectAssetId);
    // Failed background polls retain cached data.
    const failed = !tree.data ? tree : !config.data ? config : undefined;
    if (failed?.isError) {
        return (
            <PageState
                kind="error"
                title="Could not load the document tags"
                description={apiErrorMessage(failed.error, 'Try again in a moment.')}
                onRetry={() => void failed.refetch()}
            />
        );
    }
    if (!tree.data || !config.data) {
        return <PageState kind="loading" title="Loading document tags…" />;
    }
    const tagConfig = config.data;
    return (
        <LabelsTab
            projectId={projectId}
            projectAssetId={projectAssetId}
            tree={tree.data}
            config={tagConfig}
            onSaveTags={async (leafId, tags) => {
                await saveLeafTags.mutateAsync({
                    leafId,
                    tags: resolveTagsToSave(tagConfig, tags),
                });
            }}
        />
    );
}
